import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <CardsSection />
        <TopicsSection />
        <MediaSection />
        <AboutSection />
        <UpdatesSection />
        <AppSection />
        <FeaturesSection />
        <RankingSection />
        <CommentsSection />
        <CarouselSection />
        <ContactSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}